import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoggingService } from '@domgen/dgx-fe-logging';
import { CheckoutSuccessfulContract } from '@us-registration/util-models';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { RegistrationFacade } from '../../+state/registration.facade';

export const hasCheckoutContract: CanActivateFn = (
  route
): Observable<boolean> => {
  const registrationFacade = inject(RegistrationFacade);
  const loggingService = inject(LoggingService);
  const router = inject(Router);

  loggingService.debug('hasCheckoutContract', 'Start');
  const redirectTo: string = route.data?.['redirectTo'] ?? '/';

  return registrationFacade.checkoutSuccessfulContracts$.pipe(
    first(),
    map((checkoutContract: CheckoutSuccessfulContract | undefined) => {
      if (!checkoutContract) {
        router.navigate([redirectTo], {
          queryParams: route.queryParams,
          replaceUrl: true,
        });
        return false;
      }
      loggingService.debug('hasCheckoutContract', 'Success');
      return true;
    })
  );
};
